module.exports = __webpack_public_path__ + "media/images/soar/home_page_figure4-9c5138c1e4ff6732441a06af5319e611.png";